import Web3 from "web3";
const web3 = new Web3(window.ethereum);
export default web3;
